var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SocialAuthenticationButtons", {
    attrs: {
      type: "login",
      "google-title": _vm._f("trans")("Log in with %provider%", {
        "%provider%": "Google",
      }),
      "google-text": _vm._f("trans")("Continue with %provider%", {
        "%provider%": "Google",
      }),
      "facebook-title": _vm._f("trans")("Log in with %provider%", {
        "%provider%": "Facebook",
      }),
      "facebook-text": _vm._f("trans")("Continue with %provider%", {
        "%provider%": "Facebook",
      }),
      "reload-page": _vm.reloadPage,
    },
    on: {
      "auth-success": function ($event) {
        return _vm.$emit("auth-success")
      },
      "auth-fail": function ($event) {
        return _vm.$emit("auth-fail")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }